import { useEffect, useState } from "react";
import { TopUpDialog } from "@/components/wallet/TopUpDialog";

// R217 — Mounted once at the app root. Listens for the global
// `vk:wallet-insufficient` event (dispatched by the api 402 interceptor) and
// opens the top-up dialog with the failing action's context. After a
// successful top-up it fires `vk:wallet-topped-up` so the originating flow
// can prompt the user to retry.
export default function WalletTopUpManager() {
  const [open, setOpen] = useState(false);
  const [context, setContext] = useState(null);

  useEffect(() => {
    const insufficient = (e) => { setContext(e.detail || null); setOpen(true); };
    const openTopup = (e) => { setContext(e?.detail || null); setOpen(true); };
    window.addEventListener("vk:wallet-insufficient", insufficient);
    window.addEventListener("vk:open-wallet-topup", openTopup);
    return () => {
      window.removeEventListener("vk:wallet-insufficient", insufficient);
      window.removeEventListener("vk:open-wallet-topup", openTopup);
    };
  }, []);

  return (
    <TopUpDialog
      open={open}
      onOpenChange={setOpen}
      context={context}
      onToppedUp={(wallet) => {
        try {
          window.dispatchEvent(new CustomEvent("vk:wallet-topped-up", { detail: { wallet, context } }));
        } catch (_) { /* noop */ }
      }}
    />
  );
}
